// Tableau de bord de chaque rôle (redirections après connexion, accès depuis le site public).
export const normalizeRole = (r) => {
  if (!r) return '';
  const clean = String(r).toLowerCase().replace(/[-_]/g, '');
  if (clean === 'admin' || clean === 'administrative') return 'admin';
  if (clean === 'salesmanager') return 'salesmanager';
  if (clean === 'superadmin') return 'superadmin';
  if (clean === 'agencydirector' || clean === 'director' || clean === 'directeur') return 'agency_director';
  if (clean === 'comptable') return 'accounting';
  if (clean === 'technicien') return 'technician';
  if (clean === 'bailleur' || clean === 'proprietaire') return 'landlord';
  return clean;
};

export const getDashboardRoute = (role) => {
  switch (normalizeRole(role)) {
    case 'tenant': return '/tenant';
    case 'admin': return '/administrative';
    case 'accounting': return '/accounting';
    case 'salesmanager': return '/sales-manager';
    case 'technician': return '/technician';
    case 'landlord': return '/landlord';
    case 'superadmin': return '/super-admin';
    case 'agency_director': return '/agency-director';
    default: return '/tenant';
  }
};
